import { Component, OnInit } from '@angular/core';
import { FuncionalidadRolesService } from '../../../services/funcionalidad-roles.service';
import { FuncionalidadRolesFull } from '../../../models/funcionalidadRolesFull.model';
import { Router } from '@angular/router';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-listar-func',
  templateUrl: './listar-func.component.html',
  styleUrls: ['./listar-func.component.css']
})
export class ListarFuncComponent implements OnInit {

  titulo = 'Consultar funcionalidad';
  mensajeDesactivacion = 'Al desactivar una funcionalidad, ningún usuario podrá ingresar ni realizar tareas ' +
                         'en ella, sin embargo las configuraciones del usuario se conservarán, de modo que ' +
                         'si en el futuro se reactiva la funcionalidad, los usuarios podrán ingresar ' +
                         'nuevamente de acuerdo a los roles con los que cuenten';
  mensajeActivacion = 'Al reactivar una funcionalidad, los usuarios podrán ingresar nuevamente de acuerdo ' +
                      'con los roles con los que cuenten actualmente';
  funcionalidadRoles: any[] = [];
  lista: any = [];
  respuesta:any
  aplicacion:any
  objeto!: FuncionalidadRolesFull;
  roles = '';
  pagina = 1;

  constructor(private funcionalidadRolesService: FuncionalidadRolesService,
              private router: Router)
  { }

  ngOnInit(): void {
    this.cargarFuncionalidadRoles();

    $("#cancel").on("click", function() {
      $("#caja").val('');
    });
  }

  cargarFuncionalidadRoles(): void{
    this.funcionalidadRolesService.traerFuncionalidadRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.lista = this.respuesta.data
    });
  }

  cargarFuncionalidadRolesById(): void{
    this.funcionalidadRolesService.traerFuncionalidadRoles()
    .subscribe(resp => {
      this.respuesta = resp;
      this.aplicacion = this.respuesta.data[0]
    });
  }

  borrar(): void{
    this.cargarFuncionalidadRoles();
  }

  buscar(texto: string): void{
    this.funcionalidadRolesService.consultarFuncionalidadRoles(texto)
    .subscribe(resp => {
      this.respuesta = resp;
      this.lista = this.respuesta.data
      this.pagina=1;
    });
  }

  desactivarFuncionalidad(funcionalidad: any): void{
    this.ventanaEmergenteWarning(this.mensajeDesactivacion)
    .then(resp => {
      if (resp.value) {



        funcionalidad.estado="false";
        funcionalidad.idResponsable=JSON.parse(localStorage.getItem('currentUser')+"").userId;
        this.funcionalidadRolesService.actualizarFuncionalidadRoles(funcionalidad)
        .subscribe(rta => {
          if (rta.message == "El Aplicativo se ha creado exitosamente") {
            this.ventanaEmergenteExito();
            this.cargarFuncionalidadRoles();
          } else {
            this.ventanaEmergenteError();
          }
        });
      }
    });
  }

  activarFuncionalidad(funcionalidad: any): void{
    this.ventanaEmergenteWarning(this.mensajeActivacion)
    .then(resp => {
      if (resp.value) {
        funcionalidad.estado="true";
        funcionalidad.idResponsable=JSON.parse(localStorage.getItem('currentUser')+"").userId;
        this.funcionalidadRolesService.actualizarFuncionalidadRoles(funcionalidad)
        .subscribe(rta => {
          if (rta.message == "El Aplicativo se ha creado exitosamente") {
            this.ventanaEmergenteExito();
            this.cargarFuncionalidadRoles();
          } else {
            this.ventanaEmergenteError();
          }
        });
      }
    });
  }

  crearFuncionalidad(): void{
    this.router.navigateByUrl('funcionalidades/crear-funcionalidad');
  }

  ventanaEmergenteWarning(mensaje: string): Promise<SweetAlertResult>{
    let respuesta =
    Swal.fire({
      html: `${ mensaje }` +
            '<h4 class="text-warning fw-bold mt-3">¿Desea continuar?</h4>',
      iconHtml: '<img src="assets/img/warning.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Continuar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#0d6efd'
    });
    return respuesta;
  }

  ventanaEmergenteExito(): void{
    Swal.fire({
      title: 'Operación exitosa',
      iconHtml: '<img src="assets/img/success.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-success'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }

  ventanaEmergenteError(): void{
    Swal.fire({
      title: 'Operación no exitosa',
      text: 'La acción solicitada no se pudo completar',
      iconHtml: '<img src="assets/img/error.png" class="w-75 ms-2">',
      customClass: {
        icon: 'no-bordes',
        title: 'text-danger'
      },
      allowOutsideClick: false,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#0d6efd'
    });
  }
}
